import { ErrorBoundary } from 'components/common/error-boundary';
import { MachineServiceLogs } from 'components/sections/admin-portal/machines/service-logs';
import { MachineContext } from 'contexts/machine.context';
import { ServiceCategory } from 'lib_ts/enums/machine-service-logs.enums';
import { useContext } from 'react';

export const StepHardwareChanges = () => {
  const { machine } = useContext(MachineContext);

  return (
    <ErrorBoundary identifier="StepHardwareChanges">
      <MachineServiceLogs
        machine={machine}
        defaultCategory={ServiceCategory.Installation}
      />
    </ErrorBoundary>
  );
};
